import { truncate } from "./text";

import EN_MESSAGES from "constants/translation/en/messages";
import FA_MESSAGES from "constants/translation/fa/messages";

import FA_COMMON_TEXT from "constants/translation/fa/pages/common";
import EN_COMMON_TEXT from "constants/translation/en/pages/common";

export const getNotifMsg = (key, locale) => {
  if (locale === "fa") return FA_MESSAGES[key];
  return EN_MESSAGES[key];
};

export const getMessagePreviewById = (id, selectedConversation, locale) => {
  const translationObject = locale === "fa" ? FA_COMMON_TEXT : EN_COMMON_TEXT;

  const msg = selectedConversation.conversation.chats.find(
    (msg) => msg.id === id
  );

  if (msg) {
    if (msg.type === "text" || msg.type === "emoji")
      return truncate(msg?.content, 95);

    if (msg.type === "image")
      return translationObject["SPECIAL_MSG_TYPES"].IMAGE;
    if (msg.type === "audio")
      return translationObject["SPECIAL_MSG_TYPES"].AUDIO;
    if (msg.type === "file" || msg.type === "compress")
      return translationObject["SPECIAL_MSG_TYPES"].FILE;
  }
  return "-";
};
